import React from 'react';
import '../../Participants/Styles/ParticipantsStyles.scss';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import { EnumHelper } from '@singularsystems/neo-core';
import { observer } from 'mobx-react';
import { RelationshipType } from 'st-common/Participants/Models/Enums/RelationshipType';
import BeneficiariesVM from './BeneficiariesVM';
import BeneficiaryModal from 'st-common/Participants/Components/BeneficiaryModal';

@observer
export default class BeneficiariesView extends Views.ViewBase<BeneficiariesVM> {

    constructor(props: unknown) {
        super("Beneficiary", BeneficiariesVM, props);
    }

    public render() {
        return (
            <div>
                <div className="row px-3">
                    {this.viewModel.beneficiaries.length > this.viewModel.configService.maximumNumberOfBeneficiaries &&
                        <Neo.Alert className="col-sm-12 mb-2" variant={"danger"} style={{ display: "block", alignItems: "center", marginBottom: 8, maxWidth: "550px", marginRight: "auto" }} >
                            <div>
                                <b> Maximum allowed beneficiaries: </b>{this.viewModel.configService.maximumNumberOfBeneficiaries}
                            </div>
                            <div>
                                Please remove {this.viewModel.beneficiaries.length - this.viewModel.configService.maximumNumberOfBeneficiaries} beneficiary(ies) to meet the maximum allowed limit.
                            </div>
                        </Neo.Alert>
                    }
                    <Neo.Alert
                        variant={this.viewModel.totalSharePercentage === 100 ? "success" : "warning"}
                        className="beneficiaries-alert col-12 mb-3 mb-md-2"
                    >
                        <div className="beneficiaries-alert-content">
                            <span className="beneficiaries-alert-valid-label">Total Share: {this.viewModel.totalSharePercentage}%</span>
                            {this.viewModel.totalSharePercentage === 100 ? (
                                <>
                                    <span
                                        className="beneficiaries-alert-valid-icon"
                                        title="Total is 100%"
                                    ></span>
                                    <span className="beneficiaries-alert-valid-label">Valid</span>
                                </>
                            ) : (
                                <>
                                    <span
                                        className="beneficiaries-alert-valid-icon"
                                        title="Total must be 100%"
                                    ></span>
                                    <span className="beneficiaries-alert-valid-label">
                                        Total must be 100%
                                    </span>
                                </>
                            )}
                        </div>
                    </Neo.Alert>
                </div>
                <div className="overflow-x-auto-mobile">
                    <NeoGrid.Grid items={this.viewModel.beneficiaries}>
                        {beneficiary => {
                            const guardian = beneficiary.guardian;

                            return (
                                <NeoGrid.RowGroup expandProperty={beneficiary.meta.expandState}>
                                    <NeoGrid.Row>
                                        <NeoGrid.Column bind={beneficiary.meta.firstName} label={"First Name"} readOnly width={"20%"} />
                                        <NeoGrid.Column bind={beneficiary.meta.lastName} label={"Last Name"} readOnly width={"20%"} />
                                        <NeoGrid.Column bind={beneficiary.meta.dateOfBirth} label={"Date of Birth"} readOnly width={"20%"} />
                                        <NeoGrid.Column bind={beneficiary.meta.relationship} select={{ items: EnumHelper.asList(RelationshipType) }} readOnly width={"20%"} />
                                        <NeoGrid.Column bind={beneficiary.meta.sharePercentage} label={"Share Percentage"} width={"20%"} />
                                        <NeoGrid.ButtonColumn
                                            editButton={{
                                                onClick: () => {
                                                    this.viewModel.editBeneficiary(beneficiary);
                                                }
                                            }}
                                            deleteButton={{
                                                onClick: () => {
                                                    this.viewModel.deleteBeneficiary(beneficiary);
                                                }
                                            }}
                                        />
                                    </NeoGrid.Row>
                                    <NeoGrid.ChildRow>
                                        {guardian && (
                                            <NeoGrid.Grid items={[guardian]}>
                                                {g => (
                                                    <NeoGrid.Row>
                                                        <NeoGrid.Column display={g.meta.firstName} label={"Guardian First Name"} width={"20%"} />
                                                        <NeoGrid.Column display={g.meta.lastName} label={"Guardian Last Name"} width={"20%"} />
                                                        <NeoGrid.Column display={g.meta.mobileNumber} label={"Mobile Number"} width={"20%"} />
                                                        <NeoGrid.Column display={g.meta.email} label={"Email"} width={"20%"} />
                                                        <NeoGrid.Column display={g.meta.relationship} select={{ items: EnumHelper.asList(RelationshipType) }} label={"Relationship"} width={"20%"} />
                                                        <NeoGrid.ButtonColumn
                                                            editButton={{
                                                                onClick: () => {
                                                                    this.viewModel.editGuardian(beneficiary);
                                                                }
                                                            }}
                                                        />
                                                    </NeoGrid.Row>
                                                )}
                                            </NeoGrid.Grid>
                                        )}
                                    </NeoGrid.ChildRow>
                                </NeoGrid.RowGroup>
                            );
                        }}
                    </NeoGrid.Grid>
                </div>

                <div className="beneficiaries-actions">
                    <Neo.Button
                        disabled={this.viewModel.beneficiaries.length >= this.viewModel.configService.maximumNumberOfBeneficiaries}
                        variant="secondary"
                        icon="plus-circle"
                        onClick={() => this.viewModel.addBeneficiary()}
                    >
                        Add Beneficiary
                    </Neo.Button>
                    <Neo.Button
                        variant="primary"
                        icon="save"
                        onClick={() => this.viewModel.saveBeneficiaries()}
                    >
                        Update
                    </Neo.Button>
                </div>
                <BeneficiaryModal
                    viewModel={this.viewModel.beneficiaryModalVM}
                    idTypes={this.viewModel.participantsDataCache.idTypes.get()}
                    countries={this.viewModel.participantsDataCache.countries.get()} />
            </div>
        );
    }
}